"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.refreshObligationInstruction = void 0;
const web3_js_1 = require("@solana/web3.js");
const buffer_layout_1 = __importDefault(require("buffer-layout"));
const instruction_1 = require("./instruction");
const refreshObligationInstruction = (obligation, depositReserves, borrowReserves, lendingProgramID) => {
    const dataLayout = buffer_layout_1.default.struct([buffer_layout_1.default.u8('instruction')]);
    const data = Buffer.alloc(dataLayout.span);
    dataLayout.encode({ instruction: instruction_1.LendingInstruction.RefreshObligation }, data);
    const keys = [
        { pubkey: obligation, isSigner: false, isWritable: true },
    ];
    for (const depositReserve of depositReserves) {
        keys.push({ pubkey: depositReserve, isSigner: false, isWritable: false });
    }
    for (const borrowReserve of borrowReserves) {
        keys.push({ pubkey: borrowReserve, isSigner: false, isWritable: false });
    }
    return new web3_js_1.TransactionInstruction({
        keys,
        programId: lendingProgramID,
        data,
    });
};
exports.refreshObligationInstruction = refreshObligationInstruction;
